const l = {
  name: "TapToPay",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M23.9,13.7l0.5,0.9c1,1.7,1.5,3.6,1.5,5.5s-0.5,3.8-1.5,5.5l-0.5,0.9l-1.7-1l0.5-0.9c0.8-1.4,1.2-2.9,1.2-4.5
			c0-1.6-0.4-3.1-1.2-4.5l-0.5-0.9L23.9,13.7z"/>
		<path class="st0" d="M20.9,16.6l-0.5-0.9l-1.7,1l0.5,0.9c0.4,0.8,0.7,1.6,0.7,2.5c0,0.9-0.2,1.7-0.7,2.5l-0.5,0.9l1.7,1l0.5-0.9
			c0.6-1.1,0.9-2.3,0.9-3.5C21.8,18.8,21.5,17.6,20.9,16.6z"/>
		<path class="st0" d="M27.4,11.7l0.5,0.9c1.3,2.3,2,4.9,2,7.5c0,2.6-0.7,5.2-2,7.5l-0.5,0.9l-1.7-1l0.5-0.9c1.2-2,1.8-4.2,1.8-6.5
			c0-2.3-0.6-4.5-1.8-6.5l-0.5-0.9L27.4,11.7z"/>
		<path class="st0" d="M30.9,9.7l0.5,0.9c1.7,2.9,2.6,6.2,2.6,9.5s-0.9,6.6-2.6,9.5l-0.5,0.9l-1.7-1l0.5-0.9
			c1.5-2.6,2.3-5.5,2.3-8.5s-0.8-5.9-2.3-8.5l-0.5-0.9L30.9,9.7z"/>
		<path class="st0" d="M14,0c-1.7,0-3,1.3-3,3v9.5l-1.6-1.6c-1.2-1.2-3.1-1.2-4.2,0l-4.2,4.2c-1.2,1.2-1.2,3.1,0,4.2l7.1,7.1
			c0.8,0.8,2,1.1,3,0.7V37c0,1.7,1.3,3,3,3h23c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H14z M13,25.6l3.4-3.4c1.2-1.2,1.2-3.1,0-4.2
			L13,14.5V3c0-0.5,0.5-1,1-1h23c0.5,0,1,0.5,1,1v34c0,0.5-0.5,1-1,1H14c-0.5,0-1-0.5-1-1V25.6z M10.8,25c-0.4,0.4-1,0.4-1.4,0
			l-7.1-7.1c-0.4-0.4-0.4-1,0-1.4l4.2-4.2c0.4-0.4,1-0.4,1.4,0l7.1,7.1c0.4,0.4,0.4,1,0,1.4L10.8,25z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as TapToPay
};
